import { render, staticRenderFns } from "./CdIcon.vue?vue&type=template&id=198fa13e&scoped=true&"
var script = {}
import style0 from "./CdIcon.vue?vue&type=style&index=0&id=198fa13e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198fa13e",
  null
  
)

export default component.exports